import datepicker from '../../../libs/datapicker/datapicker.min.js';
import customSelect from '../../../libs/select/select';
(function ($) {
  $(document).ready(function () {
    $('.modal-input:not(.search-field) > select').customSelect();
    $('.modal-input.search-field > select').customSelect({
      search: true
    });
    $('.wpcf7-select').customSelect();
    $('[data-toggle="datepicker"]').datepicker({
      format: 'dd.mm.yyyy',
      days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      weekStart: 1,
      months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    });
    var $document = $(document);
    $document.ready(function () {
      $('input:file').change(function (e) {
        if (e.target.closest('.input-wrapper').nextElementSibling) {
          e.target.closest('.input-wrapper').nextElementSibling.textContent = e.target.files[0].name;
        }
      });
    });
  });
})(jQuery);